import { createClient } from '@supabase/supabase-js';

const getEnvValue = (value: string | undefined): string | undefined => {
  const trimmed = value?.trim();
  return trimmed || undefined;
};

export const supabaseUrl = getEnvValue(process.env.REACT_APP_SUPABASE_URL);
export const supabaseAnonKey = getEnvValue(process.env.REACT_APP_SUPABASE_ANON_KEY);
const supabaseAuthStorageKey = (() => {
  if (!supabaseUrl) return null;

  try {
    return `sb-${new URL(supabaseUrl).hostname.split('.')[0]}-auth-token`;
  } catch {
    console.warn('Invalid REACT_APP_SUPABASE_URL environment variable.');
    return null;
  }
})();

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Missing Supabase environment variables. Ensure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY are set in .env.local');
}

export const supabase = createClient(supabaseUrl ?? '', supabaseAnonKey ?? '');

export const clearLocalAuthSession = (): void => {
  if (!supabaseAuthStorageKey) return;

  localStorage.removeItem(supabaseAuthStorageKey);
  localStorage.removeItem(`${supabaseAuthStorageKey}-code-verifier`);
  localStorage.removeItem(`${supabaseAuthStorageKey}-user`);
};
